<template>
  <v-container grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card ripple hover class="border-left" color="red lighten-2" append to="neuf">
          <v-container fluid grid-list-lg>
            <v-layout row align-center>
              <v-flex xs3>
                <div class="headline">Neuf</div>
              </v-flex>
              <v-flex xs8 class="text-xs-right">
                <div class="main-data">{{ indicateurNeuf('Toutes', 'actesRealises') }} Actes</div>
                <div>{{ indicateurNeuf('Toutes', 'resasRealises') }} Réservations</div>
              </v-flex>
              <v-flex xs1 class="text-xs-right">
                <v-icon color="grey lighten-1">fas fa-angle-right</v-icon>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card ripple hover class="border-left" color="indigo lighten-2" append to="ancien">
          <v-container fluid grid-list-lg>
            <v-layout row align-center>
              <v-flex xs3>
                <div class="headline">Ancien</div>
              </v-flex>
              <v-flex xs8 class="text-xs-right">
                <div class="main-data">{{ indicateurAncien('actesRealises') }} Actes</div>
                <div>{{ indicateurAncien('resasRealises') }} Réservations</div>
              </v-flex>
              <v-flex xs1 class="text-xs-right">
                <v-icon color="grey lighten-1">fas fa-angle-right</v-icon>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card ripple hover class="border-left" color="teal lighten-2" append to="syndic">
          <v-container fluid grid-list-lg>
            <v-layout row align-center>
              <v-flex xs3>
                <div class="headline">Syndic</div>
              </v-flex>
              <v-flex xs8 class="text-xs-right">
                <div class="main-data">{{ indicateurSyndic('lots') }} lots</div>
                <div>
                  <color-indicator :formated-value="indicateurSyndic('evolution') | percent(2)" :raw-value="indicateurSyndic('evolution')"></color-indicator>
                </div>
              </v-flex>
              <v-flex xs1 class="text-xs-right">
                <v-icon color="grey lighten-1">fas fa-angle-right</v-icon>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card ripple hover class="border-left" color="blue darken-1" append to="gestion">
          <v-container fluid grid-list-lg>
            <v-layout row align-center>
              <v-flex xs3>
                <div class="headline">Gestion</div>
              </v-flex>
              <v-flex xs8 class="text-xs-right">
                <div class="main-data">{{ indicateurGestion('lots') }} lots</div>
                <div>
                  <color-indicator :formated-value="indicateurGestion('evolution') | percent(2)" :raw-value="indicateurGestion('evolution')"></color-indicator>
                </div>
              </v-flex>
              <v-flex xs1 class="text-xs-right">
                <v-icon color="grey lighten-1">fas fa-angle-right</v-icon>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card ripple hover class="border-left" color="orange lighten-2" append to="location">
          <v-container fluid grid-list-lg>
            <v-layout row align-center>
              <v-flex xs3>
                <div class="headline">Location</div>
              </v-flex>
              <v-flex xs8 class="text-xs-right">
                <div class="main-data">{{indicateurLoc('misesEnLoc', monthLoc)}} / {{indicateurLoc('objectifs', monthLoc)}}</div>
                <div>Mises en loc ({{ $moment(monthLoc+1, 'MM').format('MMMM') }})</div>
              </v-flex>
              <v-flex xs1 class="text-xs-right">
                <v-icon color="grey lighten-1">fas fa-angle-right</v-icon>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'

export default {
  name: 'Commercial',
  data(){
    return {
    }
  },
  computed: {
    ...mapGetters([
      'indicateurNeuf',
      'indicateurAncien',
      'indicateurSyndic',
      'indicateurGestion',
      'indicateurLoc',
      'serieLoc'
    ]),
    monthLoc() {
      console.log(this.serieLoc('misesEnLoc').length - 1)
      return this.serieLoc('misesEnLoc').length - 1
    }
  }
}
</script>

<style scoped>

</style>
